import React, {Component} from 'react';
import {Detail, Home, Common} from '../components';
import {db} from '../firebase/index'

export default class DetailTemplate extends Component {
    constructor(props) {
        super(props);

        this.toggleAnswerButton = (event) => {
            const isChecked = document.getElementById(event.id).checked;

            // When the user has already answered.
            if (isChecked && event.value === this.props.detail.whichChecked) {
                document.getElementById(event.id).checked = !isChecked;
                return this.props.selectAnswer(event.name, "")
            // When the user has not answered.
            } else {
                return this.props.selectAnswer(event.name, event.value)
            }
        }
    }


    componentDidMount() {
        // Query question id in the path of url like "/detail/<id>"
        const questionId = this.props.match.params.id
        this.unsubscribe = db.collection('questions').doc(questionId).onSnapshot(snapshot => {
            return this.props.updateValue(snapshot.data())
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.detail.id === "") {
            // Check the answer button if the user has already answered
            if (this.props.detail.whichChecked === 'A') {
                document.getElementById(this.props.detail.id + "_A").checked = true
            } else if (this.props.detail.whichChecked === 'B') {
                document.getElementById(this.props.detail.id + "_B").checked = true
            }
        }
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    render() {
        const detail = this.props.detail

        const hasSomeoneAnswered = (detail.result && Object.keys(detail.result).length > 0);
        let aPercent = 0;
        if (hasSomeoneAnswered) {
            const result = Object.keys(detail.result);
            const sum = result.length;
            const aResult = result.filter((index) => { return detail.result[index] === "A" });
            const aNumber = aResult.length;
            aPercent = aNumber / sum * 100;
        } else {
            aPercent = 50
        }

        // Calculate the percentage of
        let fixedAPercent = aPercent.toFixed(1);
        let fixedBPercent = (100 - aPercent).toFixed(1);
        const roundedPercent = Math.round(aPercent);

        const sharedUrl = "https://nitaku-prod.firebaseapp.com" + this.props.location.pathname;
        const sharedText = `【質問】\n${detail.question}\nＡ：${detail.answer_a}→${fixedAPercent}%\nＢ：${detail.answer_b}→${fixedBPercent}%\n`;

        return (
            <main>
                <Common.Spacer size={"medium"} quantity={2} />

                <section className={"c-section__wrapin-narrow"}>
                    <div className="p-grid__detail">
                        <Detail.ImageArea src={detail.image} />
                        <div className="p-grid-result">
                            <div>{fixedAPercent}%</div>
                            <div>{fixedBPercent}%</div>
                        </div>
                        <div className="p-grid__row-center">
                            <Home.AnswerButton id={detail.id} type="A" toggle={this.toggleAnswerButton}/>
                            <Home.ResultBar percent={roundedPercent} />
                            <Home.AnswerButton id={detail.id} type="B" toggle={this.toggleAnswerButton}/>
                        </div>
                        <div className="p-grid__detail-answer">
                            <p>Ａ：{detail.answer_a}</p>
                            <p>Ｂ：{detail.answer_b}</p>
                        </div>
                        <div></div>
                        <div className="p-grid__row-center">
                            <Detail.ShareButton type={"twitter"} text={sharedText} url={sharedUrl}/>
                            <Detail.ShareButton type={"line"} text={sharedText} url={sharedUrl}/>
                            <Detail.ShareButton type={"facebook"} text={sharedText} url={sharedUrl}/>
                        </div>
                        <div className="p-grid__detail-link">
                            <Common.PictoBadge type={"internet"} url={"#"} />
                            <Detail.LinkField url={detail.url} />
                        </div>
                        <div>{detail.description}</div>
                    </div>
                </section>
            </main>
        );
    }
}